import { createContext } from 'react'
import { MapType } from '../map/mapContext'

export const MapContext = createContext<{
  map: google.maps.Map | null
  google: typeof globalThis.google | null
  mapType: MapType | undefined
  is3D: boolean
} | null>(null)
